import { get, post } from "../../axios-interceptor-setup/apiService";

const BASE_URL = "/battery_digital_twin";

export const getCellEvent = (body) => {
    return post(`${BASE_URL}/cell_event`, body);
}

export const getTemperatureVoltageByCell = (body, apiType) => {
    return post(`${BASE_URL}/${apiType=="Temperature"?"Cell_Out_Temp_By_Cell":"Cell_Out_Volt_By_Cell"}`, body);
}

// export const getBatterySummary = (params) => {
//     return get(`${BASE_URL}/summary`, params);
// }